<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <ul class="nav">
        <li class="nav-location">
          <el-icon color="red"><LocationFilled /></el-icon>
          <span>导航</span>
          <el-icon><ArrowUp /></el-icon>
        </li>
        <li>登录</li>
        <li>注册</li>
      </ul>

      <div class="logo">
        <img width="816" height="98" src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745737727644_home-guohui.png" />
      </div>

      <div class="search">
        <ul class="search-t">
          <li class="is-select">企业信用信息</li>
          <li>经营异常名录</li>
          <li>严重违法失信名单</li>
        </ul>

        <dl class="search-c">
          <dt>
            <input type="text" placeholder="请输入企业名称、统一社会信用代码或注册号" />
          </dt>
          <dd>查&nbsp;&nbsp;&nbsp;&nbsp;询</dd>
        </dl>

        <dl class="search-b">
          <dt>
            <span>热搜榜：</span>

            <ul>
              <li>中国建筑一局(集团)有限公司</li>
              <li>中国建筑第八工程局有限公司</li>
              <li>华为技术有限公司</li>
            </ul>
          </dt>
          <dd>
            <span>更多</span>
          </dd>
        </dl>
      </div>

      <ul class="info">
        <li>
          <span></span>
          <p>信息公告</p>
        </li>
        <li @click="gotoPage('area')">
          <span></span>
          <p>企业信息填报</p>
        </li>
        <li>
          <span></span>
          <p>全国个体私营<br />经济发展服务网</p>
        </li>
        <li>
          <span></span>
          <p>重点领域信息<br />公示专区</p>
        </li>
        <li>
          <span></span>
          <p>信用修复</p>
        </li>
      </ul>
    </div>

    <div class="inspection-footer">
      <ul class="app">
        <li>
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745750576542_app_ios.png" />
          <p>苹果APP</p>
        </li>
        <li>
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745750626648_app_android.png" />
          <p>安卓APP</p>
        </li>
        <li>
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745750655505_app_wx.png" />
          <p>微信小程序</p>
        </li>
        <li>
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745750685093_app_zfb.png" />
          <p>支付宝小程序</p>
        </li>
      </ul>

      <div class="content">
        <p>主办单位：国家市场监督管理总局</p>
        <p>地址：北京市西城区三里河东路八号&nbsp;&nbsp;&nbsp;邮政编码：100820&nbsp;&nbsp;&nbsp;备案号：京ICP备18022388号-2&nbsp;&nbsp;&nbsp;010-88650267 010-88650265</p>
        <p>
          <span>业务咨询与技术支持联系方式</span>
          <span>使用帮助</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(["gotoPage"]);
const gotoPage = (page) => {
  emits("gotoPage", page);
};
</script>

<style scoped lang="scss">
.inspection-main {
  border-top: 10px solid #ab812d;
  background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745741886093_index-bg.png) no-repeat center top;
  background-size: 100% 335px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  .inspection-wrap {
    width: 1120px;
    margin: 0 auto;
    overflow: hidden;
    flex-shrink: 0;

    .nav {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #999999;
      padding: 10px;
      margin-bottom: 5px;

      li {
        margin: 0 5px;
        cursor: pointer;

        &.nav-location {
          span {
            padding: 0 2px;
          }
        }
      }
    }

    .logo {
      width: 1000px;
      height: 287px;
      margin: 0 auto;
      background: transparent url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745738095534_icon-home-ding.png) no-repeat scroll right top;
      box-sizing: border-box;
      overflow: hidden;

      img {
        display: block;
        margin: 50px auto 0;
      }
    }

    .search {
      width: 692px;
      margin: -68px auto 0;

      .search-t {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        li {
          margin-left: 63px;
          cursor: pointer;
          color: #131313;
          position: relative;

          &.is-select {
            font-weight: bold;

            &::before {
              content: "";
              display: block;
              width: 0;
              height: 0;
              position: absolute;
              left: -20px;
              top: 5px;
              border-top: 10px solid #54401f;
              border-left: 5px solid transparent;
              border-right: 5px solid transparent;
            }
          }
        }
      }

      .search-c {
        display: flex;
        align-items: center;
        height: 60px;
        background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745739750672_home-search-bg.png) no-repeat;

        dt {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 0 30px 0 50px;
          overflow: hidden;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            width: 27px;
            height: 26px;
            background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745740709792_icon-home-search.png) no-repeat;
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
          }

          input {
            font-size: 14px;
            width: 100%;
            height: 100%;
            border: 0;
            background: none;
            outline-style: none;
            padding: 0;
            margin: 0;
          }
        }

        dd {
          width: 138px;
          height: 100%;
          flex: 0 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          font-size: 18px;
          cursor: pointer;
          user-select: none;
        }
      }

      .search-b {
        display: flex;
        align-items: center;
        margin-top: 6px;

        dt {
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;

          > span {
            color: red;
          }

          ul {
            display: flex;
            align-items: center;

            li {
              width: 155px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              &:not(:nth-last-of-type(1)) {
                margin-right: 15px;
              }

              &:hover {
                cursor: pointer;
                color: blue;
              }
            }
          }
        }

        dd {
          width: 138px;
          height: 100%;
          flex: 0 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            color: red;
            cursor: pointer;
          }
        }
      }
    }

    .info {
      display: flex;
      justify-content: space-between;
      width: 852px;
      height: 140px;
      margin: 90px auto 75px;

      li {
        width: 80px;
        cursor: pointer;
        position: relative;

        &:nth-of-type(1) {
          > span {
            background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745742585963_icon-home-1.png);
          }
        }

        &:nth-of-type(2) {
          > span {
            background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745742705899_icon-home-2.png);
          }
        }

        &:nth-of-type(3) {
          > span {
            background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745742740080_icon-home-3.png);
          }
        }

        &:nth-of-type(4) {
          > span {
            background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745742795325_icon-home-5.png);
          }
        }

        &:nth-of-type(5) {
          > span {
            background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-27/1745742837441_icon-home-6.png);
          }
        }

        > span {
          display: block;
          width: 100%;
          height: 80px;
          background-size: 100% !important;
          border-radius: 50%;
          overflow: hidden;
        }

        > p {
          position: absolute;
          font-size: 16px;
          white-space: nowrap;
          margin-top: 15px;
          text-align: center;
          left: 50%;
          transform: translateX(-50%);
        }

        &:hover {
          > span {
            background-color: #f9eed1;
          }
        }
      }
    }
  }

  .inspection-footer {
    border-top: 1px solid #d5d5d5;
    flex-shrink: 0;
    text-align: center;
    font-size: 12px;
    color: #8d8d8d;
    padding: 20px 0 30px 0;
    position: relative;
    background-color: #ffffff;

    .content {
      line-height: 1.8;

      span {
        color: rgb(0, 0, 255);
        cursor: pointer;

        &:not(:nth-last-of-type(1)) {
          margin-right: 20px;
        }
      }
    }

    .app {
      position: absolute;
      left: 80px;
      top: 20px;
      display: flex;
      text-align: center;

      li {
        width: 50px;
        cursor: pointer;

        &:not(:nth-of-type(1)) {
          margin-left: 30px;
        }

        img {
          width: 50px;
          height: 50px;
        }

        p {
          line-height: 1.2;
        }
      }
    }
  }
}
</style>
